import { UntypedFormControl } from '@angular/forms'
import { ErrorStateMatcher } from '@angular/material/core'

export class NormalErrorMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null): boolean {
    const controlIntracted = !!(control?.touched || control?.dirty)
    return controlIntracted && control?.invalid
  }
}
